import { Component } from '@angular/core';

import { ShItemUploadComponent } from './item-upload.component';

@Component({
    selector: 'sh-item-upload',
    template: '',
    providers: [
        {
            provide: ShItemUploadComponent,
            useClass: ShItemUploadStubComponent
        }
    ]
})
export class ShItemUploadStubComponent {
    click(): void {}
}
